var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('div',{staticClass:"abs f-y-center bg-rock depth-8 rounded space-x-0.5 _px-1 h-2"},[(_vm.loading)?_c('loader'):_vm._e(),_c('our-label',{attrs:{"value":_vm.value,"dark":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }